import { useDocumentTitle, useScrollTop } from 'hooks';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  return (
    <div className="loader">
      <h2>{t('adminDashboardMessage')}</h2>
      <p>{t('adminDashboardParagraph')}</p>
    </div>
  );
};

export default Dashboard;
